import { ref, computed } from 'vue'

// ─────────────────────────────────────────────────────────────────────────────
// useChatHealth — periksa koneksi ke Yustian AI Engine via /api/chat/health.
// Diekstrak dari ChatAI.vue agar komponen tetap di bawah hard-limit ukuran file.
// ─────────────────────────────────────────────────────────────────────────────

export function useChatHealth() {
  const healthState     = ref('unknown')        // 'unknown' | 'connected' | 'disconnected'
  const healthMessage   = ref('Belum diuji. Klik untuk tes koneksi.')
  const healthLatencyMs = ref(null)
  const healthChecking  = ref(false)

  const healthStatusClass = computed(() => {
    if (healthChecking.value)                 return 'health-checking'
    if (healthState.value === 'connected')    return 'health-ok'
    if (healthState.value === 'disconnected') return 'health-fail'
    return 'health-unknown'
  })
  const healthLabel = computed(() => {
    if (healthChecking.value)                 return '...'
    if (healthState.value === 'connected')    return 'Online'
    if (healthState.value === 'disconnected') return 'Offline'
    return '?'
  })
  const healthTooltip = computed(() => {
    const lat = healthLatencyMs.value != null ? ` (${healthLatencyMs.value} ms)` : ''
    return `${healthMessage.value}${lat}`
  })

  async function testAiConnection() {
    if (healthChecking.value) return
    healthChecking.value = true
    healthState.value = 'unknown'
    healthMessage.value = 'Menguji koneksi…'
    try {
      const resp = await fetch('/api/chat/health', { cache: 'no-store' })
      const data = await resp.json().catch(() => null)
      if (resp.ok && data?.success && data.connected) {
        healthState.value     = 'connected'
        healthMessage.value   = data.message || 'Yustian Smart AI terhubung.'
        healthLatencyMs.value = data.latencyMs ?? null
      } else {
        healthState.value     = 'disconnected'
        healthMessage.value   = data?.message || `Gagal: HTTP ${resp.status}`
        healthLatencyMs.value = data?.latencyMs ?? null
      }
    } catch (err) {
      healthState.value     = 'disconnected'
      healthMessage.value   = err?.message || 'Gagal menghubungi server.'
      healthLatencyMs.value = null
    } finally {
      healthChecking.value = false
    }
  }

  return {
    healthState,
    healthMessage,
    healthLatencyMs,
    healthChecking,
    healthStatusClass,
    healthLabel,
    healthTooltip,
    testAiConnection,
  }
}
